import util from '@bmp-vue/core/api/util'

const controller = 'Duplicatas'

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GetAllConsolidadas: function (dto) {
    return util.Axios.GetAll(controller + '/Consolidadas', dto)
  },
  GetResumoConsolidadas: function (dto) {
    return util.Axios.GetAll(controller + '/Consolidadas/Resumo', dto)
  },
  BaixarSegundaVia: function (id) {
    return util.Axios.GetBlob(controller + '/'  + id + '/SegundaVia')
  }
})
